import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'

import InputStandard from 'components/input/standard'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import Checkbox from 'components/input/checkbox'

import { 
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import {
    saveStakeholder
} from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class ModalStakeholder extends Component {
	state = {
		id: null,
		first_name: '',
		last_name: '',
        organisation_name: '',
        position: '',
        stakeholder_category_id: '',
        address: '',
        phone_work: '',
        phone_mobile: '',
        email: '',
        website: '',
        is_private: false
	}

	inputRefs = {}
	
	componentWillMount = _ => {
		if(this.props.data){
            this.setState({
                ...this.props.data
            })
		}
	}
	
	componentDidMount = _ => { 
    	setTimeout(_ => { 
			if(this.inputRefs.first_name && this.inputRefs.first_name.inputRef){
				this.inputRefs.first_name.inputRef.focus()
			}
		}, 1)
	}

	handleSubmit = _ => {
		const {
			isLoading,
			setLoading,
			accountData,
            handleError,
			saveStakeholder
        } = this.props
        
		if(isLoading){
			return 
		}
		
		const {
			first_name,
			last_name,
			organisation_name
		} = this.state

		if(!first_name && !last_name && !organisation_name){
			return handleError(`Please enter either a name or organisation name`)
		}
        
        saveStakeholder(this.state, this.handleCallback)

		setLoading(true)
	}

	handleCallback = stakeholder => {
		const {
			setLoading,
			handleSuccess,
			closeCallback
        } = this.props
        
		setLoading(false)
		handleSuccess("Stakeholder saved successfully.")

		setTimeout(_ => {
			closeCallback()

			if(this.state.onComplete){
				this.state.onComplete(stakeholder)
			}
		}, 1000)
	}

	handleChange = (value, key) => {
		this.setState({
			[key]: value
		})	
    }

	render() {		
		const {
			isMini
		} = this.state

		const {
			accountData,
            closeCallback,
            handleDismiss,
			validateResponse,
		} = this.props
		
		let inputRows = [
			[
				{
					type: 'text',
					label: 'First name',
					key: 'first_name'
				},{
					type: 'text',
					label: 'Last name',
					key: 'last_name'
				}
			],[
				{
					type: 'text',
					label: 'Organisation',
					key: 'organisation_name'
				},{
					type: 'text',
					label: 'Position',
					key: 'position'
				}
			],[
				{
					type: 'dropdown',
					label: 'Category',
					key: 'stakeholder_category_id',
					parentType: 'categorie',
					values: accountData.stakeholder_categories ? accountData.stakeholder_categories : []
				}
			],[
				{
					type: 'text',
					label: 'Address',
					key: 'address'
				}
			],[
				{
					type: 'text',
					label: 'Phone (work)',
					key: 'phone_work'
				},{
					type: 'text',
					label: 'Phone (mobile)',
					key: 'phone_mobile'
				}
			],[
				{
					type: 'text',
					label: 'Email',
					key: 'email'
				},{
					type: 'text',
					label: 'Website',
					key: 'website'
				}
			],[
				{
					type: 'checkbox',
					label: 'Private (visible to admins only)',
					key: 'is_private'
				}
			]
		]

		if(isMini){
			inputRows = [
				[
					{
						type: 'text',
						label: 'First name',
						key: 'first_name'
					},{
						type: 'text',
						label: 'Last name',
						key: 'last_name'
					}
				],[
					{
						type: 'text',
						label: 'Organization',
						key: 'organisation_name'
					}
				]
			]
		}

		return(
			<div>
				<div className={'borders'}>
					<form className="modal-form">
						<ul>
							{ inputRows.map((row,index) => {
								let className = 'form-row'

								switch(row.length){
									case 2:
										className += ' halves'
										break
									case 3:
										className += ' thirds'
										break
								}

								return (
									<li key={index} className={className}>
										{ row.map((column, rowIndex) => {
											let input
											let showLabel = true

											switch(column.type){
												case 'text':
													input = (
														<InputStandard
															placeholder={``}
															ref={ref => this.inputRefs[column.key] = ref }
															name={column.key}
															onChange={e => this.handleChange(e.target.value, column.key)}
															value={this.state[column.key] ? this.state[column.key] : ''}
														/>
													)
													break
												case 'dropdown':
													input = (
														<DropdownMenu 
															isObjects={true} 
															selectableItems={column.values} 
															selectedItemId={this.state[column.key]} 
															handleChange={value => {this.handleChange(value, column.key)}} 
															parentType={column.parentType} 
														/>
													)
													break
												case 'checkbox':
													showLabel = false
													input = (
														<label className="checkbox-wrap">
															<Checkbox 
																isChecked={this.state[column.key]} 
																onChange={isChecked => {
																	this.handleChange(isChecked, column.key)
																}} 
															/>
															<span>
																{ column.label }
															</span>
														</label>
													)

													break
											}

											return (
												<div 
													key={rowIndex} 
													className="input-wrap"
												>
													{ showLabel &&
														<label>
															{ column.label }
														</label>	
													}
													{ input }
												</div>
											)
										}) }
									</li>
								)
							})}
						</ul>
					</form>
                    <ValidateResponse 
                        dismissCallback={handleDismiss} 
                        response={validateResponse} 
                    />
				</div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Save stakeholder'} 
					icon={'check'}
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {  
  return {
    accountData: getCurrentAccount(state),
	userData: getCurrentUser(state),
  }
}

const ModalStakeholderWithValidateResponse = withValidateResponse(ModalStakeholder)

export default connect(mapStateToProps, {
	saveStakeholder
})(ModalStakeholderWithValidateResponse)



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-stakeholder.jsx